<template>
	<div class="basic_wrap">
		<div class="top_nav">
            <div class="back_icon" @click="handleBack">
                <van-icon name="arrow-left" />
            </div>
            <div class="nav_title">{{$t('new_lang.detail')}}</div>
        </div>

		<div class="item-main">
            <!-- Header section (Blue Background) -->
            <div class="header-section">
                <div class="header-title-row">
                    <span class="project-name">{{data.title}}</span>
                    <span class="status-tag">{{$t('new_lang.in_progress')}}</span>
                </div>
                <div class="header-rate-row">
                    <span class="rate-num">{{data.rate}}</span>
                    <span class="rate-percent">%</span>
                </div>
                <div class="header-subtitle">{{$t('new_lang.expected_daily_return')}}</div>
                <div class="header-cycle-row">
                    <span class="dot"></span>
                    <span>{{data.day}}{{$t('new_lang.day_smart_feed_cycle')}}</span>
                </div>
            </div>

            <!-- Image section -->
            <div class="image-section">
                <img v-if="data.cover || data.img" :src="data.cover || data.img" alt="">
                
            </div>

            <!-- Progress section -->
            <div class="progress-section">
                <div class="progress-header">
                    <span>{{$t('new_lang.progress')}}</span>
                    <span class="percent-text">{{data.percent}}%</span>
                </div>
                <div class="progress-bar-bg">
                    <div class="progress-bar-fill" :style="'width: ' + data.percent + '%'"></div>
                </div>
                <div class="progress-stats">
                    <div class="stat-col">
                        <div class="stat-label">{{$t('new_lang.sold_shares')}}</div>
                        <div class="stat-value">{{data.buy_num || randomBuyNum}}</div>
                    </div>
                    <div class="stat-divider"></div>
                    <div class="stat-col">
                        <div class="stat-label">{{$t('new_lang.total_project_shares')}}</div>
                        <div class="stat-value">{{data.total || '50000'}}</div>
                    </div>
                </div>
            </div>

            <!-- Purchase section -->
            <div class="purchase-section">
                <div class="section-title">{{$t('new_lang.purchase_shares')}}</div>
                <div class="stepper-box">
                    <div class="stepper-input-wrap">
                        <input type="number" v-model="number" class="stepper-input" />
                        <span class="stepper-unit">{{$t('new_lang.share')}}</span>
                    </div>
                </div>
                <div class="stepper-controls">
                    <button class="step-btn btn-minus" @click="minusNumber">-</button>
                    <button class="step-btn btn-plus" @click="addNumber">+</button>
                </div>
                <div class="limit-info">
                    <span>{{$t('new_lang.min_1_share')}}</span>
                    <span>{{$t('new_lang.max_purchase')}} {{data.num || '不限'}}{{$t('new_lang.share')}}</span>
                </div>
                
                <div class="price-info">
                    <span class="price-label">{{$t('new_lang.share_price')}}</span>
                    <span class="price-value">INR{{data.min}}</span>
                </div>
                
                <div class="total-info">
                    <span class="total-label">{{$t('new_lang.investment_amount')}}</span>
                    <span class="total-value">INR{{totalAmount}}</span>
                </div>
            </div>

            <!-- Details section -->
            <div class="details-section">
                <div class="section-title">{{$t('new_lang.project_details')}}</div>
                <div class="detail-list">
                    <div class="detail-row">
                        <span class="detail-label">{{$t('new_lang.settlement_method')}}</span>
                        <span class="detail-value">{{$t('new_lang.settlement_maturity')}}</span>
                    </div>
                    <div class="detail-row">
                        <span class="detail-label">{{$t('new_lang.total_project_shares')}}</span>
                        <span class="detail-value">{{data.total || '50000'}}{{$t('new_lang.share')}}</span>
                    </div>
                    <div class="detail-row">
                        <span class="detail-label">{{$t('new_lang.sold_shares')}}</span>
                        <span class="detail-value">{{data.buy_num || randomBuyNum}}{{$t('new_lang.share')}}</span>
                    </div>
                    <div class="detail-row">
                        <span class="detail-label">{{$t('new_lang.maturity_return_handling')}}</span>
                        <span class="detail-value">{{$t('new_lang.auto_receive')}}</span>
                    </div>
                    <div class="detail-row">
                        <span class="detail-label">{{$t('new_lang.maturity_principal_handling')}}</span>
                        <span class="detail-value">{{$t('new_lang.auto_return')}}</span>
                    </div>
                </div>
            </div>
		</div>

        <!-- Fixed Bottom Button -->
        <div class="bottom-action-bar">
            <button class="btn-submit" @click="confirm">{{$t('new_lang.join_now')}}</button>
        </div>
	</div>
</template>

<script>
	import Fetch from "../../utils/fetch";
	import Vue from 'vue';
	import { Progress,Dialog,Field ,Switch} from 'vant';
	Vue.use(Progress).use(Dialog).use(Field).use(Switch);
	export default {
		name: "itemDetail",
		data() {
			return {
				data: {},
				auto_close: [],
				number: 1, // Default 1
				checked:true,
                randomBuyNum: 0, // Store random sold amount
			};
		},
        computed: {
            totalAmount() {
                return (this.number * (this.data.min || 0)).toFixed(2);
            }
        },
		created() {
			this.$parent.footer('item', false);
            this.generateRandomBuyNum();
		},
		mounted() {
			this.start();
		},
		methods: {
            handleBack() {
                if (window.history.length <= 1) {
                    this.$router.push('/item');
                } else {
                    this.$router.go(-1);
                }
            },
            generateRandomBuyNum() {
                // Generate a random number between 10000 and 50000
                this.randomBuyNum = Math.floor(Math.random() * (50000 - 10000 + 1)) + 10000;
            },
			start() {
				Fetch('/index/item_detail', {
					id: this.$router.history.current.params.code
				}).then(res => {
					this.data = res.data;
				})
			},
            minusNumber() {
                if (this.number > 1) {
                    this.number--;
                }
            },
            addNumber() {
                this.number++;
            },
			confirm(){
				if(!this.number || this.number < 1){
					this.$toast({
						className:"toastName",
						message: '最少购买1份',
					});
					return false;
				}
				Fetch("/index/item_apply", {
				  id: this.data.id,
				  money: this.totalAmount
				}).then(r => {
				  this.$router.push("/order");
				}).catch(err=>{
				    this.number = 1;
				})
			}
		}
	};
</script>

<style lang="less" scoped>
    .basic_wrap {
        background-color: #F1F4F6;
        min-height: 100vh;
        padding-bottom: 80px; // space for bottom bar
    }

	.top_nav {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 46px;
        background: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 999;
        box-shadow: 0 1px 3px rgba(0,0,0,0.05);
        
        .back_icon {
            position: absolute;
            left: 0;
            top: 0;
            height: 46px;
            width: 46px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 20px;
            color: #333;
            cursor: pointer;
            z-index: 1000;
        }
        
        .nav_title {
            font-size: 16px;
            font-weight: bold;
            color: #333;
        }
    }

	.item-main{
		margin-top: 46px;
	}

    .header-section {
        background: linear-gradient(135deg, #4B83F0 0%, #4F46E5 100%);
        padding: 20px 15px 40px;
        color: #fff;

        .header-title-row {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 15px;

            .project-name {
                font-size: 18px;
                font-weight: bold;
            }

            .status-tag {
                background: rgba(255, 255, 255, 0.2);
                padding: 2px 10px;
                border-radius: 12px;
                font-size: 12px;
                backdrop-filter: blur(4px);
            }
        }

        .header-rate-row {
            display: flex;
            align-items: baseline;
            margin-bottom: 4px;

            .rate-num {
                font-size: 36px;
                font-weight: bold;
                line-height: 1;
            }

            .rate-percent {
                font-size: 18px;
                font-weight: bold;
                margin-left: 2px;
            }
        }

        .header-subtitle {
            font-size: 12px;
            opacity: 0.9;
            margin-bottom: 12px;
        }

        .header-cycle-row {
            display: flex;
            align-items: center;
            font-size: 12px;
            opacity: 0.9;

            .dot {
                width: 4px;
                height: 4px;
                background: #fff;
                border-radius: 50%;
                margin-right: 6px;
            }
        }
    }

    .image-section {
        margin: -20px 15px 15px;
        border-radius: 12px;
        overflow: hidden;
        box-shadow: 0 4px 12px rgba(0,0,0,0.1);
        height: 200px;
        position: relative;
        z-index: 2;
        background: #fff;

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }

    .progress-section {
        background: #fff;
        margin: 0 15px 15px;
        border-radius: 12px;
        padding: 15px;
        box-shadow: 0 2px 10px rgba(0,0,0,0.02);

        .progress-header {
            display: flex;
            justify-content: space-between;
            font-size: 13px;
            color: #333;
            margin-bottom: 8px;

            .percent-text {
                font-weight: bold;
                color: #2f80ed;
            }
        }

        .progress-bar-bg {
            height: 4px;
            background: #f0f0f0;
            border-radius: 2px;
            margin-bottom: 15px;
            overflow: hidden;

            .progress-bar-fill {
                height: 100%;
                background: #2f80ed;
                border-radius: 2px;
            }
        }

        .progress-stats {
            display: flex;
            align-items: center;

            .stat-divider {
                width: 1px;
                height: 20px;
                background: #eee;
            }

            .stat-col {
                flex: 1;
                text-align: center;

                .stat-label {
                    font-size: 12px;
                    color: #999;
                    margin-bottom: 4px;
                }

                .stat-value {
                    font-size: 14px;
                    font-weight: bold;
                    color: #333;
                }
            }
        }
    }

    .purchase-section {
        background: #fff;
        margin: 0 15px 15px;
        border-radius: 12px;
        padding: 15px;
        box-shadow: 0 2px 10px rgba(0,0,0,0.02);

        .section-title {
            font-size: 15px;
            font-weight: bold;
            color: #333;
            margin-bottom: 15px;
        }

        .stepper-box {
            margin-bottom: 10px;

            .stepper-input-wrap {
                background: #f8f9fa;
                border-radius: 8px;
                border: 1px solid #e0e0e0;
                display: flex;
                align-items: center;
                padding: 0 15px;

                .stepper-input {
                    flex: 1;
                    width: 100%;
                    height: 54px;
                    background: transparent;
                    border: none;
                    text-align: center;
                    font-size: 24px;
                    font-weight: bold;
                    color: #333;
                    outline: none;
                    padding-left: 20px; /* offset the right "份" text to keep it centered */
                }

                .stepper-unit {
                    color: #666;
                    font-size: 14px;
                    white-space: nowrap;
                }
            }
        }

        .stepper-controls {
            display: flex;
            gap: 10px;
            margin-bottom: 15px;

            .step-btn {
                flex: 1;
                height: 44px;
                border: 1px solid #e0e0e0;
                border-radius: 8px;
                font-size: 20px;
                color: #333;
                cursor: pointer;
                background: #fff;
                display: flex;
                align-items: center;
                justify-content: center;
                
                &.btn-plus {
                    background: #2f80ed;
                    border-color: #2f80ed;
                    color: #fff;
                }
            }
        }

        .limit-info {
            display: flex;
            justify-content: space-between;
            font-size: 12px;
            color: #999;
            margin-bottom: 20px;
        }

        .price-info {
            display: flex;
            justify-content: space-between;
            font-size: 13px;
            color: #666;
            margin-bottom: 10px;

            .price-value {
                font-weight: bold;
                color: #2f80ed;
            }
        }

        .total-info {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 15px;
            background: #e6f7ff;
            border-radius: 8px;
            margin-top: 15px;
            border: 1px solid rgba(24, 144, 255, 0.2);

            .total-label {
                font-size: 14px;
                color: #2f80ed;
            }

            .total-value {
                font-size: 18px;
                font-weight: bold;
                color: #2f80ed;
            }
        }
    }

    .details-section {
        background: #fff;
        margin: 0 15px;
        border-radius: 12px;
        padding: 15px;
        box-shadow: 0 2px 10px rgba(0,0,0,0.02);

        .section-title {
            font-size: 15px;
            font-weight: bold;
            color: #333;
            margin-bottom: 15px;
        }

        .detail-list {
            .detail-row {
                display: flex;
                justify-content: space-between;
                padding: 12px 0;
                border-bottom: 1px solid #f5f5f5;

                &:last-child {
                    border-bottom: none;
                    padding-bottom: 0;
                }

                .detail-label {
                    font-size: 13px;
                    color: #666;
                }

                .detail-value {
                    font-size: 13px;
                    font-weight: 500;
                    color: #333;
                }
            }
        }
    }

    .bottom-action-bar {
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        padding: 10px 15px;
        background: #fff;
        box-shadow: 0 -2px 10px rgba(0,0,0,0.05);
        z-index: 100;

        .btn-submit {
            width: 100%;
            height: 44px;
            background: #2f80ed;
            color: #fff;
            border: none;
            border-radius: 22px;
            font-size: 16px;
            font-weight: bold;
            cursor: pointer;
        }
    }

	.sw-grid{
		display: flex;
		align-items: flex-end;
		margin-top: 20px;
		.sw-row:first-child{
			margin-bottom:20px;
		}
		.sw-row > div:first-child{
			margin-bottom: 10px;
		}
		
		.sw-info{
			color: #999;
		}
		.sw-val.text-green{
			font-size: 16px;
		}
	}
	.sw-right{
		text-align: center;
		.sw-lg{
			font-size: 24px;
			margin-bottom: 10px;
		}
	}
	
	.flex_bd{
		flex: 1;
	}
</style>
